function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 41.5 51"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M40.2 17.4c-3.4 2.1-5.5 5.7-5.5 9.7 0 4.5 2.7 8.6 6.8 10.3-.8 2.6-2 5-3.5 7.2-2.2 3.1-4.5 6.3-7.9 6.3s-4.4-2-8.4-2c-3.9 0-5.3 2.1-8.5 2.1s-5.4-2.9-7.9-6.5C2 39.5.1 33.7 0 27.6c0-9.9 6.4-15.2 12.8-15.2 3.4 0 6.2 2.2 8.3 2.2 2 0 5.2-2.3 9-2.3 4-.1 7.8 1.8 10.1 5.1M28.3 8.1C30 6.1 30.9 3.6 31 1c0-.3 0-.7-.1-1-2.9.3-5.6 1.7-7.5 3.9-1.7 1.9-2.7 4.3-2.8 6.9 0 .3 0 .6.1.9.2 0 .5.1.7.1 2.7-.2 5.2-1.6 6.9-3.7",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgApple;